import { mapGetters } from 'vuex';
import PriceCard from './PriceCard';
import Button from '../shared/Button';
import ProductDetails from './ProductDetails';
import Accounting from '../../mixins/accounting';
import ImageUrlFallback from '../../mixins/imageUrlFallback';
import VehicleVisualSummary from './VehicleVisualSummary';
import VehicleCardLocalisations from '../../lang/VehicleCard';
import branding from '../../mixins/branding';
import Tooltip from '../shared/Tooltip';
import modifications from '../../mixins/modifications';

require('./scss/vehicle-card.scss');

export default {
    name: 'vehicle-card',

    components: {
        'gm-button': Button,
        'gm-tooltip': Tooltip,
        PriceCard,
        ProductDetails,
        VehicleVisualSummary,
    },

    mixins: [Accounting, ImageUrlFallback, branding, modifications],

    props: ['vehicle', 'buy', 'labels', 'locale', 'selectVehicle', 'showTermsAndConditions', 'handleLogin', 'vehicleExternalId', 'selectedProductType', 'experiment'],

    template: `
    <div v-if="currentVehicle"
         class="vehicle vehicle-upgrade">
        <vehicle-visual-summary
          :vehicle="vehicle"
          :labels="labels"
          :currentVehicle="currentVehicle"
          :currencyIsChanging="currencyIsChanging"
          :activeProduct="activeProduct"
          :cardType="'row-source-booking'"
          :experiment="experiment"
        ></vehicle-visual-summary>
        <div class="price-block-mobile expanded">
            <button
                type="button"
                class="upgrade-product w-100 expanded"
                data-toggle="modal"
                :data-target="'#current-car-details-modal-' + currentVehicle.id"
                v-if="!isFullModification"
                :aria-label="$t('VehicleCard.change_plan')"
            >
                <div>
                    <img :src="icons[activeProduct.type]" alt="" />
                </div>
                <span class="upgrade-product-arrow" aria-hidden="true"></span>
            </button>

            <div  class="details-section">
                <product-details
                    :product="activeProduct"
                    :vehicle="vehicle"
                    :currency-is-changing="currencyIsChanging"
                    upsell-card-type="mobile-us-product-upsell"
                    :show-terms-and-conditions="showTermsAndConditions"
                    :experiment="experiment"
                ></product-details>
            </div>

            <div class="book-default w-100">
                <div
                    class="d-flex flex-column price-card-total align-items-start"
                >
                    <span>
                        <strong class="original-amount" v-if="activeProduct.original_price && !currencyIsChanging">{{ originalPrice(activeProduct) }}</strong>
                        <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                        <strong class="amount original-amount-mobile" v-else>{{ vehiclePrice }}</strong>
                        <strong class="text-lowercase gm-text-black">{{ labels.extraPerDay }}</strong>
                    </span>
                    <span>
                        <gm-tooltip :text="labels.loyaltyAppliedInsteadOfPromo" class="d-inline-block" click="enabled" v-if="loyaltyHigherThanPromo">
                            <i class="fa fa-info-circle text-brand"></i>
                        </gm-tooltip>
                        <strong class="text-capitalize gm-text-black">{{ labels.total }}</strong>
                        <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                        <strong class="gm-text-black" v-else>{{ vehiclePriceTotal }}</strong>
                    </span>
                </div>
                
                <gm-button
                    @click="selectVehicleHandler(vehicle, activeProduct.id);"
                    v-if="((user && vehicle.is_drive_and_go && activeProduct.is_available) || (!vehicle.is_drive_and_go && activeProduct.is_available)) && (vehicle.external_id !== vehicleExternalId)"
                    type="select"
                    :mobile-classes="true"
                    :disabled="disabledButtonStatus || (vehicle.external_id === vehicleExternalId)"
                >
                    {{ labels.bookNow }}
                </gm-button>
                <gm-button
                    v-else
                    type="select"
                    :mobile-classes="true"
                    disabled
                >
                    {{ $t('PriceCard.current_choice') }}
                </gm-button>

                <gm-button
                    top-right-radius="0"
                    top-left-radius="0"
                    :disabled="true"
                    :mobile-classes="true"
                    v-if="!activeProduct.is_available"
                >
                    {{ $t('VehicleCard.age_limit', { age: activeProduct.minimum_age }) }}
                </gm-button>


            </div>

        </div>

        <div class="d-none d-sm-block prices-block">
            <div class="price-cards">
                <div
                    v-for="product in products"
                    :class="[setDisplayProduct(product)]"
                >
                    <price-card
                        :class="{
                            active: product.type === activeProduct.type,
                            highlight: product.type === highlightedProduct
                        }"
                        class="h-100 row-price-card"
                        upsellCardType="row-product-upsell"
                        :key="product.type"
                        :product="product"
                        :vehicle="vehicle"
                        :labels="labels"
                        :buy="buy"
                        :show-terms-and-conditions="showTermsAndConditions"
                        :currency-is-changing="currencyIsChanging"
                        :select-vehicle="selectVehicleHandler"
                        :selected-currency="selectedCurrency"
                        :user="user"
                        :handle-login="handleLogin"
                        :vehicle-external-id="vehicleExternalId"
                        :selected-product-type="selectedProductType"
                        :loyalty-higher-than-promo="loyaltyHigherThanPromo"
                        :experiment="experiment"
                    ></price-card>
                </div>
            </div>
        </div>

        <div class="modal gm-full-modal" tabindex="-1" :id="'current-car-details-modal-' + currentVehicle.id">
            <div class="modal-dialog">
                <div class="modal-content overflow-auto">
                    <div class="modal-body">
                        <div class="d-flex align-items-center justify-content-between">
                            <span  class="h4">{{ $t('VehicleCard.change_plan') }}</span>
                            <button type="button" class="btn btn-icon h2" data-dismiss="modal" aria-label="Close">
                                <img :src="brandingImagesPath('/images/svgs/close-black.svg')" alt="Close" />
                            </button>
                        </div>

                        <div>
                            <transition name="fade">
                                <div class="prices">
                                    <div
                                        class="price"
                                        v-for="product in reversedProducts"
                                        :class="product.type"
                                        :key="product.type"
                                    >
                                        <div class="price-body">
                                            <div class="header">
                                                <div class="product-type">
                                                    <img :src="icons[product.type]">
                                                </div>
                                            </div>
                                            <product-details
                                                :show-terms-and-conditions="showTermsAndConditions"
                                                :product="product"
                                                :currency-is-changing="currencyIsChanging"
                                                :experiment="experiment"
                                            ></product-details>
                                        </div>
                                        <div class="mobile-products-price">
                                            <div v-if="product.total_price >= activeProduct.total_price"  class="total">
                                                &plus;&nbsp;{{ selectedPriceDiffBasePrice(activeProduct, product, quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                                            </div>
                                            <div v-else  class="total">
                                                &minus;&nbsp;{{ selectedPriceDiffBasePrice(activeProduct, product, quoteHireDuration) }} <small>{{ labels.extraPerDay }}</small>
                                            </div>
                                        </div>
                                        <div class="choose-product disabled-button" v-if="product.type === activeProduct.type" disabled>
                                            {{ $t('VehicleCard.current') }}
                                        </div>
                                        <div class="choose-product" @click="selectVehicleHandler(vehicle, product.id)" v-else-if="product.is_available" data-dismiss="modal">
                                            {{ $t('VehicleCard.upgrade') }}
                                        </div>
                                        <div class="choose-product product-disabled" disabled="disabled" v-if="!product.is_available" data-dismiss="modal">
                                            {{ $t('VehicleCard.age_limit', {age: product.minimum_age}) }}
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    i18n: VehicleCardLocalisations,
    data() {
        return {
            currencyIsChanging: false,
            imageErrorUrls: [],
            currentVehicle: null,
            disabledButtonStatus: false,
            product: null,
            showAllProducts: false,
            products: [],
            reversedProductsList: [],
            displayProducts: {
                BAS: 'basic',
                PMP: 'premium plus+',
            },
            icons: {
                BAS: this.brandingImagesPath('/images/vehicle-listing/basic-badge.svg'),
                PLU: this.brandingImagesPath('/images/vehicle-listing/plus-badge.svg'),
                PRE: this.brandingImagesPath('/images/vehicle-listing/premium-badge.svg'),
                PMP: this.brandingImagesPath('/images/vehicle-listing/premium-plus-badge.svg'),
            },
            productLabels: {
                BAS: 'basic',
                PLU: 'plus',
                PRE: 'premium',
                PMP: 'premium plus+',
            },
            highlightedProduct: 'PMP',
            carDetailsModalToShow: null,
            vehiclePricePerDay: 0,
        };
    },

    mounted() {
        this.currentVehicle = this.vehicle;
        this.mapProducts(this.currentVehicle);
        window.bus.$on('currency.changed', this.currencyChanging);
        window.bus.$on('vehicle.selected', this.disableButton);
    },

    beforeDestroy() {
        window.bus.$off('currency.changed', this.currencyChanging);
        window.bus.$off('vehicle.selected', this.disableButton);
    },

    watch: {
        'booking.reference': {
            immediate: true,
            handler(bookingId) {
                if (!bookingId) {
                    return;
                }

                const bookingKey = this.booking?.reference || bookingId;

                if (!bookingKey) {
                    return;
                }

                this.$store.dispatch('fetchLastModification', {
                    bookingId: bookingKey,
                });
            },
        },

        vehicle: function (vehicle) {
            this.mapProducts(vehicle, true);
            this.currencyIsChanging = false;
        },
        quoteHireDuration: function (duration) {
            this.vehiclePricePerDay = this.originalPricePerDay(this.activeProduct, duration);
        },
    },

    computed: Object.assign(
        {
            vehiclePrice() {
                let product = this.activeProduct;
                let bookingProduct = this.booking?.quote?.data?.selected_vehicle?.data?.product?.data;
                let price = this.lastModification?.vehicle_total || bookingProduct?.total_price_with_discounts || product.total_price_with_discounts;

                // For booking mods, when selecting a cheaper vehicle, we want to show the price of the selected vehicle, because the user won't be refunded, so the vehicle price will be the price of the selected vehicle, not the original price of the booking
                if (product.total_price_with_discounts <= price) {
                    return this.quoteHireDuration > 1 ? this.formatMoney(price / this.quoteHireDuration, this.selectedCurrency.code) : this.formatMoney(price, this.selectedCurrency.code);
                }

                return this.quoteHireDuration > 1 ? this.originalPricePerDay(product, this.quoteHireDuration) : this.formatMoney(product.total_price_with_discounts, this.selectedCurrency.code);
            },

            vehiclePriceTotal() {
                let product = this.activeProduct;
                let bookingProduct = this.booking?.quote?.data?.selected_vehicle?.data?.product?.data;
                let price = this.lastModification?.vehicle_total || bookingProduct?.total_price_with_discounts || product.total_price_with_discounts;

                // For booking mods, when selecting a cheaper vehicle, we want to show the price of the selected vehicle, because the user won't be refunded, so the vehicle price will be the price of the selected vehicle, not the original price of the booking
                if (product.total_price_with_discounts <= price) {
                    return this.formatMoney(price, this.selectedCurrency.code);
                }

                // If there's a modification, the total price should include the promo discount.
                if (this.modification && this.modification?.status !== '') {
                    return this.formatMoney(product.total_price_with_discounts, this.selectedCurrency.code);
                }

                return this.price(product);
            },

            reversedProducts() {
                this.reversedProductsList = [...this.products];
                return this.reversedProductsList.reverse();
            },
            activeProduct() {
                let activeProducts = this.products.filter((product) => product.active);

                // For booking mods we want to show the selected product only
                if (this.isFullModification) {
                    let selectedProductType = this.quote?.selected_vehicle?.data?.product?.data?.type;

                    const activeProduct = this.products.find((product) => product.type === selectedProductType);

                    if (activeProduct) {
                        return activeProduct;
                    }
                }

                return activeProducts.length > 0 ? activeProducts[0] : {};
            },
            pluralizationEnabled() {
                return !['tr'].includes(this.locale);
            },
            userLoyalty() {
                if (!this.user) {
                    return null;
                }

                const data = this.user.loyalty_level.data;

                return {
                    name: data.name,
                    image: this.brandingImagesPath(`/images/loyalty-icons/medals/${data.slug}.svg`),
                };
            },
            loyaltyDiscountApplied() {
                return this.vehicle.loyalty_discount_applied && this.userLoyalty;
            },
            pickupLocationIsUK() {
                return this.pickupLocation.country && this.pickupLocation.country.data.id === 1;
            },
            productUpgrades() {
                return this.products.filter((product) => {
                    return product.type !== this.vehicle.default_product.type;
                });
            },
            loyaltyHigherThanPromo() {
                if (!this.quote) {
                    return false;
                }

                return this.quote.is_loyalty_higher_than_promo;
            },
        },
        mapGetters({
            quotePaymentType: 'quotePaymentType',
            quoteHireDuration: 'quoteHireDuration',
            selectedCurrency: 'selectedCurrency',
            user: 'getQuoteUser',
            quote: 'getQuote',
            pickupLocation: 'getPickupLocation',
            booking: 'getBooking',
            lastModification: 'getLastModification',
        })
    ),

    methods: {
        currencyChanging() {
            this.currencyIsChanging = true;
        },
        mapProducts(vehicle, isUpdate) {
            this.products = vehicle.products.data.map((product) => {
                let originalProduct = this.products.filter((previousProduct) => previousProduct.id == product.id);

                let aProduct = Object.assign(originalProduct.length > 0 ? originalProduct[0] : {}, product);

                if (!isUpdate) {
                    aProduct.active = false;

                    if (vehicle.default_product && product.type === vehicle.default_product.type) {
                        aProduct.active = true;
                    }
                }

                return aProduct;
            });
        },
        upgradeProduct() {
            this.showAllProducts = !this.showAllProducts;
        },
        setActiveProduct(vehicle, product) {
            this.products = this.products.map((aProduct) => {
                aProduct.active = false;
                return aProduct;
            });
            product.active = true;
        },
        setDisplayProduct(product) {
            let displayProducts = this.displayProducts;

            // For booking mods we only want to display one product, which should be the selected one.
            if (this.isFullModification) {
                let selectedProductType = this.quote?.selected_vehicle?.data?.product?.data?.type;

                displayProducts = {
                    [selectedProductType]: this.productLabels[selectedProductType],
                };
            }

            if (displayProducts[product.type]) {
                return 'd-block';
            }

            return 'd-none';
        },
        disableButton() {
            this.disabledButtonStatus = true;
        },
        selectVehicleHandler(vehicle, activeProductId) {
            window.bus.$emit('vehicle.selected');
            window.bus.$emit('vehicle.selecting');

            if (typeof this.booking !== 'undefined' && this.booking !== null && this.booking?.reference !== null && typeof this.booking?.reference !== 'undefined') {
                // For booking modifications, we need to find the correct product based on the original quote's selected vehicle rental code
                let rentalCode = this.quote?.selected_vehicle?.data?.product?.data?.type;
                let selectedProduct = this.products.find((product) => product.type === rentalCode);

                this.selectVehicle(vehicle, selectedProduct?.id ?? activeProductId);
            } else {
                this.selectVehicle(vehicle, activeProductId);
            }
        },
    },
};
